module.exports = __webpack_public_path__ + "static/media/lotus.02e01341.svg";